import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useWorkOS } from '../../features/workos/context/WorkOSContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ component }) => {
  const { isAuthenticated, isLoading, login } = useWorkOS();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Store the current path (including search params) for redirect after login
      const returnPath = location.pathname + location.search;
      localStorage.setItem('workos_return_to', returnPath);
      
      // Trigger WorkOS login instead of redirecting to home
      login();
    }
  }, [isLoading, isAuthenticated, location, login]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    // Show a message while redirecting to login
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <LoadingSpinner />
          <p className="text-white mt-4">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return component;
};

export default ProtectedRoute;